import 'babel-polyfill'
import Vue from 'vue'
import router from 'routers'
import store from 'store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import 'yunji-components/lib/yunji-components.css'
import * as yunjiComponents from 'yunji-components'
import App from 'App.vue'
import axios from 'axios'
// 接入监控
// import { YjErrorReport } from '@yunji/report'

/*
** 输入JENKINS信息，非必须，如果需要统计到包版本信息才加
*/
const returnPackage = () => {
  if(typeof window.JENKINS !== 'undefined' && window.JENKINS.packageName) {
    return {
      packageName: window.JENKINS.packageName,
      packageVersion: window.JENKINS.packageVersion
    }
  }
  return {}
}
/*
** 调用
*/
const hostname = window.location.hostname && window.location.hostname.split('.')[0]
// const yjerror = new YjErrorReport(Vue, {
//   projectName: 'popadminweb',
//   environment: hostname !== 'seller' ? 'test' : 'release',
//   packageName: returnPackage().packageName,
//   packageVersion: returnPackage().packageVersion,
//   ajaxCodefilter: [302, 401]
// })
// 修改图片上次的默认地址
yunjiComponents.ImgGroupUpload.props.action.default = '/popadmin/admin/file/upload'
yunjiComponents.ImgUpload.props.action.default = '/popadmin/admin/file/upload'
yunjiComponents.ImgUpload.props.name.default = 'file'
yunjiComponents.ImgGroupUpload.props.name.default = 'file'
yunjiComponents.ImgUpload.props.accept.default = '.jpg,.jpeg,.png'
yunjiComponents.VideoUpload.props.accept.default = '.mp4'

//import Home from './views/home/home.vue'

import 'styles/style.less'
import 'styles/style.css'
import VueDnd from 'awe-dnd'

// import '../public/static/newUeditor/themes/default/css/ueditor.css'
// import '../public/static/newUeditor/themes/iframe.css'
// import '../public/static/newUeditor/third-party/codemirror/codemirror.css'

// import '../public/static/newUeditor/ueditor.config.js'
// import '../public/static/newUeditor/ueditor.all.js'
// import '../public/static/newUeditor/lang/zh-cn/zh-cn.js'
//埋点
(function (param) {
    var p = param.sdkUrl,
        n = param.name,
        w = window,
        d = document,
        s = "script",
        x = null,
        y = null
    w["ThinkingDataAnalyticalTool"] = n
    w[n] =
        w[n] ||
        function (a) {
            return function () {
                (w[n]._q = w[n]._q || []).push([a, arguments])
            }
        }
    var methods = [
        "track",
        "quick",
        "login",
        "logout",
        "trackLink",
        "userSet",
        "userSetOnce",
        "userAdd",
        "userDel",
        "setPageProperty"
    ]
    for (var i = 0; i < methods.length; i++) {
        w[n][methods[i]] = w[n].call(null, methods[i])
    }
    if (!w[n]._t) {
        x = d.createElement(s), y = d.getElementsByTagName(s)[0]
        x.async = 1
        x.src = p
        y.parentNode.insertBefore(x, y)
        w[n].param = param
    }
})({
    appId: '0ff618f5f5d145f396ad7af729a69a0d', //系统分配的APPID
    name: "thinkingReport", //全局的调用变量名，可以任意设置，后续的调用使用该名称即可
    sdkUrl: "https://static.yunjiglobal.com/qnUpload/frontend/js/thinkingdata_1.0.5.js", //统计脚本URL
    serverUrl: "//ta.yunjiglobal.com/sync_js",
    showLog: false,
    send_method: 'ajax'
})
// 全局配置
Vue.config.productionTip = false
// Vue.config.errorHandler = function (err, vm, info) {
//   // 用作全局页面处理
//   // 异步则跳到 500 错误页面，并将错误信息传递过去
// }
Vue.use(ElementUI, {
    size: 'small'
})
Vue.use(yunjiComponents)
Vue.use(VueDnd)
// axios 配置
axios.defaults.withCredentials = true
axios.defaults.timeout = 5000
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
axios.interceptors.response.use(
    res => {
        return res
    },
    err => {
        if (err && err.response) {
            let status = err.response.status
            switch (status) {
                case 302:
                    location.href = `/popadminweb/login`
                    break
                case 401:
                    location.href = `/popadminweb/login`
                    return new Promise((resolve, reject) => {}) // 为了防止 401 不弹报错信息（不resolve也不reject）
                case 403:
                    new Message({
                        //在vue示例外调用$message
                        message: '你没有权限操作！',
                        type: 'error'
                    })
                    break
                default:
                    break
            }
        }
        return Promise.reject(err)
    }
)
Vue.prototype.$axios = axios

/**
 * @method 导航前卫构造
 * @param { to } 进入的导航
 * @return { form } 来自的导航
 * @desc
 */
/* router.beforeEach((to, form, next) => {
    if (to.path == '/login') { //进入导航前调用一个方法 判断是否登录 若是登录了一个账户 直接跳转到首页
        axios.get(`/popadmin/admin/user/loginStatus`).then(res => {
            if (res.data.code == 0) {
                router.replace('/index')
            } else {
                next()
            }
        }, err => {
            next()
        })
    } else if (to.path == '/index') {
        axios.get(`/popadmin/admin/user/loginStatus`).then(res => {
            if (res.data.code == 1) { //登录失效
                router.replace('/login')
            } else {
                next()
            }
        }, err => {
            next()
        })
    } else {
        next()
    }
}) */
// router.beforeEach((to, from, next) => {
//  if(to.path != '/login'){
//   //console.log(get_cookie('JESSIONID').split(":")[0])
//  // !!get_cookie('JESSIONID') && JSON.parse(get_cookie('JESSIONID')).split(":")[0] == 'outUser' ? next() : next({ path: '/login' })
//   !!get_cookie('JESSIONID') && get_cookie('JESSIONID').split(":")[0] == '"outUser' ? next() : next({ path: '/login' })
//  }else {
//   next()
//  }
// })

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')